<!--
 * @Author: 忠于自己 429022021@qq.com
 * @Date: 2025-07-07 11:19:07
 * @LastEditors: 忠于自己 429022021@qq.com
 * @LastEditTime: 2025-07-16 12:57:45
 * @FilePath: \duilvpcbase\src\views\originality\children\createQE\components\newAsideRight.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="aside-p">
    <div class="aside-cover-p"
         @click="scrollToCover">
      <div></div>
      <p>基础检查</p>
    </div>
    <div class="aside-scene-p"
         style="height: 78px;text-align:center;"
         @click="scrollToScene">
      <div></div>
      <p>现场标样制作</p>
    </div>
    <div class="aside-quality-p"
         style="height: 78px;text-align:center;"
         @click="scrollToQuality">
      <div></div>
      <p>原材料进场</p>
    </div>
    <div class="aside-material-p"
         style="height: 78px;text-align:center;"
         @click="scrollToMaterial">
      <div></div>
      <p>施工过程管控</p>
    </div>
    <div class="aside-extrinsic-p"
         @click="scrollToExtrinsic">
      <div></div>
      <p>外部因素</p>
    </div>
    <div class="aside-spot-p"
         @click="scrollToSpot">
      <div></div>
      <p>成品抽检</p>
    </div>
    <div class="aside-info-p"
         @click="scrollToInfo">
      <div></div>
      <p>信息反馈</p>
    </div>
    <div class="aside-commentcss-p"
         @click="scrollToCommentcss">
      <div></div>
      <p>评论</p>
    </div>
    <div class="aside-liked-p"
         @click="like"
         :class="{active:isLiked}">
      <div></div>
      <p>点赞</p>
    </div>
    <div class="aside-top-p"
         @click="scrollToTop">
      <img src="../../../../../html/pages/originality/createQe/images/arrow1.png"
           alt="">
    </div>
  </div>
</template>

<script>
import "../../../../../html/components/createQE/newAsideRight.scss";

import { like } from "../../../../../api/index"

export default {
  name: 'asideRight',
  data () {
    return {
      isLiked: false,
    }
  },
  props: {
    isLike: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLike (n) {
      this.isLiked = n
    }
  },
  methods: {
    scrollToCover () {
      this.$emit("scrollToCover")
    },
    scrollToScene () {
      this.$emit("scrollToScene")
    },
    scrollToQuality () {
      this.$emit("scrollToQuality")
    },
    scrollToMaterial () {
      this.$emit("scrollToMaterial")
    },
    scrollToExtrinsic () {
      this.$emit("scrollToExtrinsic")
    },
    scrollToSpot () {
      this.$emit("scrollToSpot")
    },
    scrollToInfo () {
      this.$emit("scrollToInfo")
    },
    scrollToCommentcss () {
      this.$emit("scrollToCommentcss")
    },
    like () {
      this.$emit("like")
    },
    async like () {
      let res = await like({
        id: this.$route.params.id,
        //token: "fb4b719afa2db43ed0f03e1446672cd959fd1070"
      })
      if (res.type = "Success") {
        if (res.Content.indexOf('点赞') > -1) {
          this.isLiked = true
        } else if (res.Content.indexOf('取消') > -1) {
          this.isLiked = false
        }
      }
    },
    scrollToTop () {
      this.$emit("scrollToTop")
    }
  }
}
</script>
